<template>
  <div id="phoneNumber">
    <v-form ref="phoneForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 sm12 md12 class="pr-0 button-container">
            <v-btn fab absolute left :href="'#/configuration'" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="text-xs-right" v-if="dirty">
              <v-btn class="pf-btn pf-btn-cancel" @click="dirty=false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout>
          <v-flex md6 sm8 xs12>
              <v-text-field label="Phone Number" :rules="[formRules.number, formRules.phoneRules]" v-model="newPhone.number" @input="dirty=true" class="pr-4 pl-4 required"></v-text-field>
         </v-flex>
        </v-layout>
        <v-layout>
            <v-flex md6 sm8 xs12>
                <v-text-field label="Country Code" :rules="[formRules.country_code, formRules.countryCodeNumber]" v-model="newPhone.country_code" @input="dirty=true" class="pr-4 pl-4 required"></v-text-field>
           </v-flex>
          </v-layout>
      </v-container>
      <v-container mt-5 pt-5>
        <v-layout class="pr-4 pl-4">
          <v-flex xs12 sm12 md12 class="pr-0" v-if="dirty">
            <div class="text-xs-right">
              <v-btn class="pf-btn pf-btn-cancel" @click="dirty=false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session store */
import swal from 'sweetalert2';
import { update } from '../helpers/helpers';

export default {
  components: {},
  data: () => ({
    dirty: false,
    entity: 'Agency',
    newPhone: {
      country_code: '+1',
      number: ''
    },
    formRules: {
      number: value => !!value || 'Phone Number is required',
      phoneRules: (v) => /^(\d{8}|\d{9}|\d{10})$/.test(v) || 'Please enter valid phone number',
      countryCodeNumber: (v) => /^(\+?\d{1,3}|\d{1,4})$/.test(v) || 'Please enter valid country code',
      country_code: value => !!value || 'Country Code is required'
    },
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  methods: {
    async save () {
      if (this.$refs.phoneForm.validate()) {
        if (this.Agency.phone) {
          this.Agency.phone.push(this.newPhone);
        } else {
          this.Agency.phone = [this.newPhone];
        }
        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Phone number saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/configuration' });
            }
          });
        }
      }
    }
  }
};
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Phone.vue